import { render, staticRenderFns } from "./CustomerDaButton.vue?vue&type=template&id=790a5c52"
import script from "./CustomerDaButton.vue?vue&type=script&lang=js"
export * from "./CustomerDaButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports